import React, { useCallback } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { NavLink, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useGetSurveyByIdQuery } from "../../../features/surveys/surveysApiSlice";
import { selectCurrentToken } from "../../../features/auth/authSlice";
import Iconify from "../../../components/iconify";
import SurveyEvaluationView from "./SurveyEvaluationView";
import SurveyCorrelationAnalysis from "./SurveyCorrelationAnalysis";
import Loading from "../../../components/spinners/Loading";

let SERVER_URL = "/api";
if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  SERVER_URL = "http://localhost:5001/api";
}

function SurveyEvaluation() {
  const { surveyId } = useParams();
  const { data, isLoading, isFetching } = useGetSurveyByIdQuery(surveyId);
  const token = useSelector(selectCurrentToken);

  const handleExport = useCallback(
    async (format) => {
      try {
        const response = await fetch(
          `${SERVER_URL}/survey/${surveyId}/export?format=${format}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          alert(err.message || "Export fehlgeschlagen.");
          return;
        }
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download =
          response.headers
            .get("Content-Disposition")
            ?.match(/filename="?([^"]+)"?/)?.[1] ||
          `survey_export.${format}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch {
        alert("Export fehlgeschlagen.");
      }
    },
    [surveyId, token]
  );

  if (isLoading || isFetching) {
    return <Loading />;
  }

  return (
    <Box sx={{ ml: 3 }}>
      <Button
        component={NavLink}
        to={"/dashboard/survey"}
        // onClick={() => handleChangeMenuState("/dashboard/files")}
        variant="contained"
        color="warning"
        sx={{ minWidth: 100, mb: 2 }}
        startIcon={<Iconify icon="mdi:arrow-left" />}
      >
        zurück
      </Button>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 2 }}
      >
        <Typography textAlign={"left"} variant="h2">
          Auswertung
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="mdi:file-delimited-outline" />}
            onClick={() => handleExport("csv")}
          >
            CSV Export
          </Button>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="mdi:file-excel-outline" />}
            onClick={() => handleExport("xlsx")}
          >
            Excel Export
          </Button>
        </Stack>
      </Stack>
      {/* <SurveyEvaluationPieChart
        title="Hier den Titel der Frage"
        chartData={[
          { label: "Fehler", value: 20 },
          {
            label: "Beschwerden",
            value: 30,
          },
          { label: "Risiken", value: 50 },
        ]}
        chartColors={[
          "#d9f3f2",
          "#aee3e4",
          "#48aead",
          // theme.palette.warning.main,
          // theme.palette.primary.main,
        ]}
      /> */}

      {data?.survey && (
        <>
          <SurveyEvaluationView
            surveyQuestions={data?.survey?.surveyQuestions}
            surveyAnswers={data?.survey?.surveyAnswers}
          />
          <SurveyCorrelationAnalysis
            surveyId={surveyId}
            surveyQuestions={data?.survey?.surveyQuestions}
          />
        </>
      )}
    </Box>
  );
}

SurveyEvaluation.propTypes = {};

export default SurveyEvaluation;
